const prefixUrl = process.env.REACT_APP_BE_URL;

export const getSurveyResultsByEmail = (email) => fetch(`${prefixUrl}/typeform/getSurveyResultsByEmail/${email}`).then(response => response.json());